import React from 'react'
import Header from './layout/Header';
import { Navigate, Route, Routes } from 'react-router-dom';
import Footer from './layout/Footer';
import AuthModals from './global/AuthModals';
import ScrollToTopButton from './global/ScrollToTopButton';
import HomePage from './pages/HomePage';
import ViewPropertyPage from './pages/ViewPropertyPage';
import PropertiesPage from './pages/PropertiesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

function MainWrapper() {

  return (
    <>
      {/* <Preload /> */}
      <div id="wrapper">
        <div id="pagee" className="clearfix">
          <Header />
          <Routes>
            <Route path="/" Component={HomePage} />
            
            <Route path="/properties" Component={PropertiesPage} />
            <Route path="/properties/:id" Component={ViewPropertyPage} />

            <Route path='/about' element={<AboutPage />} />
            <Route path='/contact' element={<ContactPage />} />          


            <Route path="*" element={<Navigate to={"/not-found"} replace />} />
          </Routes>
          <Footer />
        </div>
      </div>

      <AuthModals />
      <ScrollToTopButton />
    </>
  );
}

export default MainWrapper